var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "im-option",
      on: {
        click: function ($event) {
          $event.stopPropagation()
          return _vm.handleClick.apply(null, arguments)
        },
      },
    },
    [
      _vm.$slots.default
        ? [_vm._t("default")]
        : _c("div", { staticClass: "item", class: _vm.itemClass }, [
            _c("span", { staticClass: "label" }, [
              _vm._v(_vm._s(_vm.currentLabel)),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "icon" },
              [
                !_vm.select.multiple
                  ? [
                      _c("span", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.selected,
                            expression: "selected",
                          },
                        ],
                        staticClass: "iconfont icon-checked-light",
                      }),
                    ]
                  : [
                      _c("Checkbox", {
                        attrs: { theme: _vm.theme, value: _vm.selected },
                      }),
                    ],
              ],
              2
            ),
          ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }